import Vue from 'vue';
import { isNillOrEmpty } from '@utils/helpers';
import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DetailedStatsFormatter, GeneralStatsFormatter } from '@pbx/services/StatsFormatter';

class StatServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params = {}) {
    return this.http.get(`/`, { params });
  }

  async getGeneral(params = {}) {
    const data = await this.http.get(`/general`, { params });
    if (params && params.group_by) {
      const formatted_data = await GeneralStatsFormatter(data, params.group_by);
      return { data: formatted_data };
    }
    return { data };
  }

  async getDetailed(params = {}) {
    let stats = await this.http.get(`/detailed`, { params });
    let old_params;
    const { current_page, total_pages } = stats.meta;
    const { contact_id, destination, dst_number, src_number, state, type } = params;

    if (isNillOrEmpty(old_params)) old_params = params;

    if (current_page > total_pages ||
      contact_id !== old_params.contact_id ||
      destination !== old_params.destination ||
      dst_number !== old_params.dst_number ||
      src_number !== old_params.src_number ||
      state !== old_params.state ||
      type !== old_params.type) {
      const param = Vue.$R.merge(params, { current_page: 1 });
      return this.getDetailed(param);
    }

    stats.data = await DetailedStatsFormatter(stats.data);
    return stats;
  }
}

export const StatService = new StatServiceClass({
  api_version: 2,
  resource: 'pbx/stats'
});
